<template>
    <div>
        <rkm-area
            background-color="secondary"
            title="Desfecho"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-radio-group
                        :validations="validations.desfecho"
                        class="mt-1 mb-2"
                        name="Desfecho"
                        v-model="data.model.desfecho.finalizado"
                    >
                        <rkm-form-radio :value="true">Liberar paciente</rkm-form-radio>
                        <rkm-form-radio :value="false">Manter na fila</rkm-form-radio>
                        <rkm-form-radio :value="'encaminhar'">Encaminhar</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>
            </rkm-row>

            <template v-if="data.model.desfecho.finalizado === false || data.model.desfecho.finalizado === 'encaminhar'">
                <rkm-row v-if="data.additionals.isDemandaEspontanea === true">
                    <rkm-col>
                        <rkm-form-select
                            :disabled="demandaEspontaneaObservaVagaAtendimento"
                            :options="data.form.desfecho.usuarios"
                            @change="handleUsuarioChange"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="data.model.desfecho.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :disabled="demandaEspontaneaObservaVagaAtendimento"
                            :options="data.form.desfecho.ocupacoes"
                            @change="handleOcupacaoChange"
                            label="CBO"
                            show-default-option
                            text-field="descricao"
                            v-model="data.model.desfecho.ocupacaoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :disabled="demandaEspontaneaObservaVagaAtendimento"
                            :options="data.form.desfecho.especialidades"
                            label="Especialidade"
                            show-default-option
                            text-field="nome"
                            v-model="data.model.desfecho.especialidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col v-if="demandaEspontaneaObservaVagaAtendimento">
                        <rkm-form-select
                            :options="data.form.desfecho.jornadas"
                            disabled
                            label="Jornada"
                            show-default-option
                            text-field="descricao"
                            v-model="data.model.desfecho.jornadaId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row v-if="data.form.desfecho.servicos.length > 0">
                    <rkm-col>
                        <rkm-form-checkbox-group
                            :options="data.form.desfecho.servicos"
                            label="Serviços"
                            text-field="nome"
                            v-model="data.model.desfecho.servicos"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-select
                            :label="data.model.desfecho.finalizado === 'encaminhar' ? 'Opção de entrada (Atual)' : 'Opção de entrada'"
                            :options="data.form.desfecho.opcoesEntrada"
                            :validations="validations.opcaoEntrada"
                            disabled
                            show-default-option
                            text-field="nome"
                            v-model="data.model.desfecho.opcaoEntradaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col v-if="data.model.desfecho.finalizado === false">
                        <rkm-form-select
                            :options="data.form.desfecho.prioridades"
                            :validations="validations.prioridade"
                            label="Prioridade"
                            show-default-option
                            text-field="nome"
                            v-model="data.model.desfecho.prioridadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <template v-if="data.model.desfecho.finalizado === 'encaminhar'">
                    <rkm-row>
                        <rkm-col cols="4">
                            <rkm-form-select
                                :options="data.form.desfecho.modulosEncaminhamento"
                                :validations="validations.moduloEncaminhamento"
                                @change="handleModuloEncaminhamentoChange"
                                label="Módulo"
                                show-default-option
                                text-field="nome"
                                v-model="data.model.desfecho.moduloEncaminhamentoId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-select
                                :options="data.form.desfecho.centrosCustoEncaminhamento"
                                :validations="validations.centroCustoEncaminhamento"
                                @change="handleCentroCustoEncaminhamentoChange"
                                label="Setor"
                                show-default-option
                                text-field="setorNome"
                                v-model="data.model.desfecho.centroCustoEncaminhamentoId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-select
                                :options="data.form.desfecho.opcoesEntradaEncaminhamento"
                                :validations="validations.opcaoEntradaEncaminhamento"
                                label="Opção de entrada"
                                show-default-option
                                text-field="nome"
                                v-model="data.model.desfecho.opcaoEntradaEncaminhamentoId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="4">
                            <rkm-form-select
                                :options="data.form.desfecho.prioridades"
                                :validations="validations.prioridade"
                                label="Prioridade"
                                show-default-option
                                text-field="nome"
                                v-model="data.model.desfecho.prioridadeId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>
                </template>
            </template>
        </rkm-area>
    </div>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                desfecho: {required: true},
                prioridade: {
                    required: this.data.model.desfecho.finalizado === 'encaminhar'
                        ? (!!this.data.model.desfecho.opcaoEntradaEncaminhamentoId
                            && !!this.data.form.desfecho.opcoesEntradaEncaminhamento.find(opcaoEntrada => opcaoEntrada.id === this.data.model.desfecho.opcaoEntradaEncaminhamentoId).prioridadeObrigatoria
                        )
                        : (!!this.data.model.desfecho.opcaoEntradaId
                            && this.data.form.desfecho.opcoesEntrada.find(opcaoEntrada => opcaoEntrada.id === this.data.model.desfecho.opcaoEntradaId).prioridadeObrigatoria
                        )
                },
                moduloEncaminhamento: {required: true},
                centroCustoEncaminhamento: {required: true},
                opcaoEntradaEncaminhamento: {required: true},
            }
        },
        demandaEspontaneaObservaVagaAtendimento() {
            return this.data.form.desfecho.especialidades.find(especialidade => especialidade.id === this.data.model.desfecho.especialidadeId)?.demandaEspontaneaObservaVagaAtendimento === true
        },
    },
    created() {
        this.repositories = {
            atendimentoEnfermagem: this.getConectaSusRepository('ambulatorio.atendimentoEnfermagem'),
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleUsuarioChange(value) {
            this.data.form.desfecho.ocupacoes = []
            this.data.form.desfecho.especialidades = []
            this.data.model.desfecho.ocupacaoId = null
            this.data.model.desfecho.especialidadeId = null

            if (value === null) return

            this.getOcupacoes(value)
        },
        handleOcupacaoChange(value) {
            this.data.form.desfecho.especialidades = []
            this.data.model.desfecho.especialidadeId = null

            if (value === null) return

            this.getEspecialidades(this.data.model.desfecho.usuarioId, value)
        },
        getOcupacoes(usuarioId) {
            const request = {
                funcionalidade: 'pos-consulta',
                listar: 'ocupacoes',
                filaId: this.filaId,
                usuarioId,
            }

            this.setLoading()

            this.repositories.atendimentoEnfermagem.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.data.form.desfecho.ocupacoes = Object.assign(response.data.ocupacoes)

                    if (this.data.form.desfecho.ocupacoes.length === 1) {
                        const ocupacaoId = this.data.form.desfecho.ocupacoes[0].id

                        this.data.model.desfecho.ocupacaoId = ocupacaoId

                        this.getEspecialidades(this.data.model.desfecho.usuarioId, ocupacaoId)
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEspecialidades(usuarioId, ocupacaoId) {
            const request = {
                funcionalidade: 'pos-consulta',
                listar: 'especialidades',
                filaId: this.filaId,
                usuarioId,
                ocupacaoId,
            }

            this.setLoading()

            this.repositories.atendimentoEnfermagem.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.data.form.desfecho.especialidades = Object.assign(response.data.especialidades)

                    if (this.data.form.desfecho.especialidades.length === 1) {
                        this.data.model.desfecho.especialidadeId = this.data.form.desfecho.especialidades[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleModuloEncaminhamentoChange() {
            this.data.form.desfecho.centrosCustoEncaminhamento = []
            this.data.model.desfecho.centroCustoEncaminhamentoId = null
            this.data.form.desfecho.opcoesEntradaEncaminhamento = []
            this.data.model.desfecho.opcaoEntradaEncaminhamentoId = null

            if (!this.data.model.desfecho.moduloEncaminhamentoId) return

            const request = {
                funcionalidade: 'pos-consulta',
                origem: 'encaminhamento',
                listar: 'centros-custo-encaminhamento',
                opcaoEntradaOrigemId: this.data.model.desfecho.opcaoEntradaId,
                moduloId: this.data.model.desfecho.moduloEncaminhamentoId,
            }

            this.setLoading()

            this.repositories.atendimentoEnfermagem.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.data.form.desfecho.centrosCustoEncaminhamento = Object.assign(response.data.centrosCustoEncaminhamento)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleCentroCustoEncaminhamentoChange() {
            this.data.form.desfecho.opcoesEntradaEncaminhamento = []
            this.data.model.desfecho.opcaoEntradaEncaminhamentoId = null

            if (!this.data.model.desfecho.centroCustoEncaminhamentoId) return

            const request = {
                funcionalidade: 'pos-consulta',
                origem: 'encaminhamento',
                listar: 'opcoes-entrada-encaminhamento',
                opcaoEntradaOrigemId: this.data.model.desfecho.opcaoEntradaId,
                moduloId: this.data.model.desfecho.moduloEncaminhamentoId,
                centroCustoId: this.data.model.desfecho.centroCustoEncaminhamentoId,
            }

            this.setLoading()

            this.repositories.atendimentoEnfermagem.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.data.form.desfecho.opcoesEntradaEncaminhamento = Object.assign(response.data.opcoesEntradaEncaminhamento)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, repository, stringCase],
    props: {
        data: {type: Object, required: true},
        filaId: {type: Number, required: true},
    },
}
</script>